module.exports = __webpack_public_path__ + "img/35.688a7e64.jpg";